import React, { useState } from "react";
import PropTypes from "prop-types";
import RadioGroup from "../components/RadioGroup";
import FormSection from "../components/FormSection";
import FormSelect from "../components/FormSelect";
import FormInput from "../components/FormInput";
import backArrow from "../images/Layer 51.svg";
import SignaturePopup from "../components/SignaturePopup";
import PhotoUploader from "../components/PhotoUploader/PhotoUploader";

const BelongingsDevicesForm = ({
  primaryColor = "#1F3047",
  secondaryColor = "#349AC8",
  textColor = "#181818",
  placeholderColor = "#717171",
  onBack = () => {},
  onSubmit = () => {},
  data,
}) => {
  // Form state
  const [formData, setFormData] = useState({
    hasItemsToStore: data?.belongingsDevices?.hasItemsToStore ?? null,
    storedItems: {
      driversLicense:
        data?.belongingsDevices?.storedItems?.driversLicense ?? false,
      insuranceCard:
        data?.belongingsDevices?.storedItems?.insuranceCard ?? false,
      governmentID: data?.belongingsDevices?.storedItems?.governmentID ?? false,
      socialSecurityCard:
        data?.belongingsDevices?.storedItems?.socialSecurityCard ?? false,
      cash: data?.belongingsDevices?.storedItems?.cash ?? false,
      creditDebitCards:
        data?.belongingsDevices?.storedItems?.creditDebitCards ?? false,
      wallet: data?.belongingsDevices?.storedItems?.wallet ?? false,
      bankChecks: data?.belongingsDevices?.storedItems?.bankChecks ?? false,
      jewelry: data?.belongingsDevices?.storedItems?.jewelry ?? false,
      other: data?.belongingsDevices?.storedItems?.other ?? false,
      otherDetails: data?.belongingsDevices?.storedItems?.otherDetails ?? "",
    },
    devices: data?.belongingsDevices?.devices?.map((device) => ({
      type: device?.type ?? "",
      serialNumber: device?.serialNumber ?? "",
      hasCharger: device?.hasCharger ?? null,
      condition: device?.condition ?? "",
    })) ?? [
      {
        type: "",
        serialNumber: "",
        hasCharger: null,
        condition: "",
      },
    ],
    hasRestrictedItems: data?.belongingsDevices?.hasRestrictedItems ?? null,
    restrictedItemsList: data?.belongingsDevices?.restrictedItemsList ?? "",
    specialInstructions: data?.belongingsDevices?.specialInstructions ?? "",
    cardType: data?.belongingsDevices?.storedItems?.cardType ?? "",
    cardNumber: data?.belongingsDevices?.storedItems?.cardNumber ?? "",
    cashAmount: data?.belongingsDevices?.storedItems?.cashAmount ?? "",
  });

  const [showSignaturePopup, setShowSignaturePopup] = useState(false);
  const [signatureText, setSignatureText] = useState("Patient Signature");
  const [signatureData, setSignatureData] = useState(null);
  const [staffSignatureData, setStaffSignatureData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStoredItemChange = (item) => {
    setFormData((prev) => ({
      ...prev,
      storedItems: {
        ...prev.storedItems,
        [item]: !prev.storedItems[item],
      },
    }));
  };

  const handleDeviceChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedDevices = [...prev.devices];
      updatedDevices[index][name] = value;
      return { ...prev, devices: updatedDevices };
    });
  };

  const handleDeviceRadioChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedDevices = [...prev.devices];
      updatedDevices[index][field] = value;
      return { ...prev, devices: updatedDevices };
    });
  };

  const addDevice = () => {
    setFormData((prev) => ({
      ...prev,
      devices: [
        ...prev.devices,
        {
          type: "",
          serialNumber: "",
          hasCharger: null,
          condition: "",
        },
      ],
    }));
  };

  const handleRadioChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Call the onSubmit prop with the complete form data
    onSubmit(formData);
  };

  // const handleClientSignature = () => {
  //   console.log("Signature confirmed");
  //   setSignatureText("staff Signature");
  //   setShowSignaturePopup(true);
  // };

  // const handleClearSignature = () => {
  //   console.log("Signature cleared");
  // };

  // const handleConfirmSignature = (sigData) => {
  //   console.log("Signature confirmed");
  //   setShowSignaturePopup(false);
  //   if (signatureText === "Client Signature") {
  //     setSignatureData(sigData);
  //     window.localStorage.setItem("signatureData", sigData);
  //   } else {
  //     setStaffSignatureData(sigData);
  //     window.localStorage.setItem("staffSignatureData", sigData);
  //   }
  //   console.log("signatureData", signatureData);
  // };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "48px",
          padding: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Main Title */}
        <div
          style={{
            alignSelf: "stretch",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              color: primaryColor,
              fontSize: "32px",
              fontFamily: "Mauren, sans-serif",
              fontWeight: "100",
              margin: 0,
            }}
          >
            Belongings & Devices
          </h1>
          <div style={{ textAlign: "center" }}>
            <span
              style={{
                color: primaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
                lineHeight: "24px",
              }}
            >
              This section is intended for completion by authorized Legacy
              Healing{" "}
            </span>
            <span
              style={{
                color: secondaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "700",
                lineHeight: "24px",
              }}
            >
              staff only
            </span>
            <span
              style={{
                color: primaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
                lineHeight: "24px",
              }}
            >
              .
            </span>
          </div>
        </div>

        {/* Form Sections */}
        <div
          style={{
            alignSelf: "stretch",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          {/* Personal Items Section */}
          <FormSection
            title="Personal Items to Be Stored in the Safe"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            <div style={formRowStyle}>
              <RadioGroup
                label="Do you have personal items to store?"
                name="hasItemsToStore"
                value={formData.hasItemsToStore}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("hasItemsToStore", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
              />
            </div>

            {formData.hasItemsToStore && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    color: textColor,
                    fontSize: "12px",
                    fontFamily:
                      "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                    fontWeight: "400",
                  }}
                >
                  Select the items being stored:
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  {/* Checkbox Items */}
                  <CheckboxItem
                    label="Driver's License"
                    checked={formData.storedItems.driversLicense}
                    onChange={() => handleStoredItemChange("driversLicense")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Insurance Card"
                    checked={formData.storedItems.insuranceCard}
                    onChange={() => handleStoredItemChange("insuranceCard")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Government ID"
                    checked={formData.storedItems.governmentID}
                    onChange={() => handleStoredItemChange("governmentID")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Social Security Card"
                    checked={formData.storedItems.socialSecurityCard}
                    onChange={() =>
                      handleStoredItemChange("socialSecurityCard")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Cash"
                    checked={formData.storedItems.cash}
                    onChange={() => handleStoredItemChange("cash")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Credit/Debit Card(s)"
                    checked={formData.storedItems.creditDebitCards}
                    onChange={() => handleStoredItemChange("creditDebitCards")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Wallet"
                    checked={formData.storedItems.wallet}
                    onChange={() => handleStoredItemChange("wallet")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Bank Checks"
                    checked={formData.storedItems.bankChecks}
                    onChange={() => handleStoredItemChange("bankChecks")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Jewelry"
                    checked={formData.storedItems.jewelry}
                    onChange={() => handleStoredItemChange("jewelry")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Other"
                    checked={formData.storedItems.other}
                    onChange={() => handleStoredItemChange("other")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                </div>

                {formData.storedItems.other && (
                  <FormInput
                    label="Please specify other items"
                    name="otherDetails"
                    value={formData.storedItems.otherDetails}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        storedItems: {
                          ...prev.storedItems,
                          otherDetails: e.target.value,
                        },
                      }))
                    }
                    placeholder="Describe other items being stored"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                )}
                {formData.storedItems.creditDebitCards && (
                  <div style={formRowStyle}>
                    <FormInput
                      label="Card Type"
                      name="cardType"
                      value={formData.cardType}
                      onChange={handleChange}
                      placeholder="Ex: Visa, Mastercard, Amex"
                      color={secondaryColor}
                      textColor={textColor}
                      placeholderColor={placeholderColor}
                    />
                    <FormInput
                      label="Card Last 4 Digits"
                      name="cardNumber"
                      value={formData.cardNumber}
                      onChange={handleChange}
                      placeholder="Ex: 1234"
                      color={secondaryColor}
                      textColor={textColor}
                      placeholderColor={placeholderColor}
                      maxLength={4}
                    />
                  </div>
                )}
                {formData.storedItems.cash && (
                  <div style={formRowStyle}>
                    <FormInput
                      label="cash Amount"
                      name="cashAmount"
                      value={formData.cashAmount}
                      onChange={handleChange}
                      placeholder="Ex: 20"
                      color={secondaryColor}
                      textColor={textColor}
                      placeholderColor={placeholderColor}
                    />
                  </div>
                )}
              </div>
            )}
          </FormSection>

          {/* Phones & Electronics Section */}
          <FormSection
            title="Phones & Electronics"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            {formData.devices.map((device, index) => (
              <React.Fragment key={index}>
                <div style={formRowStyle}>
                  <FormInput
                    label="Device Type"
                    name="type"
                    value={device.type}
                    onChange={(e) => handleDeviceChange(index, e)}
                    placeholder="Ex: iPhone 13, Smartwatch"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                  <FormInput
                    label="Serial Number (Optional)"
                    name="serialNumber"
                    value={device.serialNumber}
                    onChange={(e) => handleDeviceChange(index, e)}
                    placeholder="Ex: SN01234X"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                </div>
                <div style={formRowStyle}>
                  <RadioGroup
                    label="Is the charger included?"
                    name={`hasCharger-${index}`}
                    value={device.hasCharger}
                    options={["Yes", "No"]}
                    onChange={(value) =>
                      handleDeviceRadioChange(
                        index,
                        "hasCharger",
                        value === "Yes"
                      )
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <FormInput
                    label="Condition of Device"
                    name="condition"
                    value={device.condition}
                    onChange={(e) => handleDeviceChange(index, e)}
                    placeholder="Ex: Screen cracked, no charger"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                </div>
                {index < formData.devices.length - 1 && (
                  <div style={dividerStyle} />
                )}
              </React.Fragment>
            ))}

            <button
              type="button"
              onClick={addDevice}
              style={{
                padding: "12px 16px",
                background: secondaryColor,
                borderRadius: "16px",
                border: "none",
                color: "white",
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                alignSelf: "flex-start",
              }}
            >
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  borderRadius: "50%",
                  border: "2px solid white",
                }}
              >
                <div
                  style={{
                    width: "12px",
                    height: "2px",
                    background: "white",
                    position: "absolute",
                  }}
                />
                <div
                  style={{
                    width: "2px",
                    height: "12px",
                    background: "white",
                    position: "absolute",
                  }}
                />
              </div>
              Add Another Device
            </button>
          </FormSection>

          {/* Additional Notes & Warnings Section */}
          <FormSection
            title="Additional Notes & Warnings"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            <div style={formRowStyle}>
              <RadioGroup
                label="Are you carrying any sharp objects or restricted items?"
                name="hasRestrictedItems"
                value={formData.hasRestrictedItems}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("hasRestrictedItems", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
              />
              {formData.hasRestrictedItems && (
                <FormInput
                  label="If yes, please list them"
                  name="restrictedItemsList"
                  value={formData.restrictedItemsList}
                  onChange={handleChange}
                  placeholder="Ex: Razor blades, scissors, needles"
                  color={secondaryColor}
                  textColor={textColor}
                  placeholderColor={placeholderColor}
                />
              )}
            </div>
            <FormInput
              label="Notes or special instructions"
              name="specialInstructions"
              value={formData.specialInstructions}
              onChange={handleChange}
              placeholder="Ex: Keep wallet with me at all times."
              color={secondaryColor}
              textColor={textColor}
              placeholderColor={placeholderColor}
              height="140px"
              multiline
            />
          </FormSection>
        </div>
        <FormSection>
          <PhotoUploader />
        </FormSection>

        {/* <div
          style={{
            flex: "1 1 0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <div
            style={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                color: textColor,
                fontSize: "12px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
              }}
            >
              staff Signature
            </div>
            <div
              style={{
                alignSelf: "stretch",
                height: "150px",
                background: "white",
                borderRadius: "8px",
                outline: `1px ${secondaryColor} solid`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={() => handleClientSignature()}
            >
              {staffSignatureData ? (
                <img
                  src={staffSignatureData}
                  alt="Client Signature"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              ) : (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "rgba(112.62, 112.62, 112.62, 0.50)",
                    fontSize: "48px",
                    fontFamily: "Turbinado Pro, sans-serif",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  staff Signature
                </div>
              )}
            </div>
          </div>
        </div>

        {showSignaturePopup && (
          <SignaturePopup
            clientSignatureText={signatureText}
            onClose={() => setShowSignaturePopup(false)}
            onClear={handleClearSignature}
            onConfirm={handleConfirmSignature}
          />
        )} */}

        {/* Form Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "24px",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onBack}
            style={{
              padding: "12px 16px",
              borderRadius: "16px",
              outline: `1px solid ${secondaryColor}`,
              border: "none",
              background: "transparent",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: "24px",
                height: "24px",
                padding: "6px",
                background: secondaryColor,
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={backArrow} alt="" />
            </div>
            <span
              style={{
                color: primaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
              }}
            >
              Back to Medical Info
            </span>
          </button>

          <button
            onClick={() => onSubmit(formData)}
            style={{
              padding: "12px 16px",
              background: secondaryColor,
              borderRadius: "16px",
              border: "none",
              color: "white",
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              cursor: "pointer",
            }}
          >
            Continue to Review & Confirm
          </button>
        </div>
      </div>
    </form>
  );
};

const CheckboxItem = ({ label, checked, onChange, color, textColor }) => (
  <div
    style={{
      padding: "8px 0",
      display: "flex",
      alignItems: "center",
      gap: "16px",
      cursor: "pointer",
    }}
    onClick={onChange}
  >
    <div
      style={{
        width: "24px",
        height: "24px",
        padding: "2px",
        position: "relative",
        overflow: "hidden",
        borderRadius: "4px",
        outline: `1px solid ${color}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: checked ? color : "transparent",
      }}
    >
      {checked && (
        <div
          style={{
            width: "15px",
            height: "10px",
            borderBottom: "2px solid white",
            borderLeft: "2px solid white",
            transform: "rotate(-45deg)",
            marginBottom: "2px",
          }}
        />
      )}
    </div>
    <span
      style={{
        textAlign: "center",
        color: textColor,
        fontSize: "16px",
        fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
        fontWeight: "400",
        lineHeight: "24px",
      }}
    >
      {label}
    </span>
  </div>
);

// Style constants
const formRowStyle = {
  display: "flex",
  gap: "24px",
  width: "100%",
};

const formFieldStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  flex: "1 1 0",
};

const labelStyle = (color) => ({
  color,
  fontSize: "12px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "400",
});

const inputContainerStyle = (color) => ({
  padding: "12px 16px",
  background: "white",
  borderRadius: "8px",
  outline: `1px solid ${color}`,
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flex: "1 1 0",
});

const inputStyle = (placeholderColor) => ({
  flex: "1 1 0",
  border: "none",
  outline: "none",
  background: "transparent",
  color: "inherit",
  fontSize: "16px",
  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
  fontWeight: "400",
  lineHeight: "24px",
  "::placeholder": {
    color: placeholderColor,
  },
});

const radioGroupStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const radioStyle = (color, checked) => ({
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  outline: `1.5px solid ${color}`,
  position: "relative",
  cursor: "pointer",
  backgroundColor: checked ? color : "transparent",
});

const radioInnerStyle = {
  position: "absolute",
  top: "4px",
  left: "4px",
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  background: "white",
};

const radioLabelStyle = (color) => ({
  color,
  fontSize: "16px",
  fontFamily: "Montserrat, sans-serif",
  fontWeight: "400",
  lineHeight: "20px",
});

const dividerStyle = {
  height: "1px",
  width: "100%",
  background: "#e0e0e0",
  margin: "16px 0",
};

// PropTypes
BelongingsDevicesForm.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  textColor: PropTypes.string,
  placeholderColor: PropTypes.string,
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default BelongingsDevicesForm;
